module.exports = __webpack_public_path__ + "assets/86.jpg?7995d3c03393cb2b4b6975fe24ef38e4";